/**
 * Country dialing codes used by the contact form phone selector.
 *
 * Each entry: { code: ISO-3166-1 alpha-2, dial: '+XX', name, flag emoji }.
 * Order: France pinned first, then the rest alphabetical by display name.
 */
const REST = [
  { code: "AF", dial: "+93", name: "Afghanistan", flag: "🇦🇫" },
  { code: "ZA", dial: "+27", name: "Afrique du Sud", flag: "🇿🇦" },
  { code: "AL", dial: "+355", name: "Albanie", flag: "🇦🇱" },
  { code: "DZ", dial: "+213", name: "Algérie", flag: "🇩🇿" },
  { code: "DE", dial: "+49", name: "Allemagne", flag: "🇩🇪" },
  { code: "AD", dial: "+376", name: "Andorre", flag: "🇦🇩" },
  { code: "AO", dial: "+244", name: "Angola", flag: "🇦🇴" },
  { code: "AG", dial: "+1268", name: "Antigua-et-Barbuda", flag: "🇦🇬" },
  { code: "SA", dial: "+966", name: "Arabie saoudite", flag: "🇸🇦" },
  { code: "AR", dial: "+54", name: "Argentine", flag: "🇦🇷" },
  { code: "AM", dial: "+374", name: "Arménie", flag: "🇦🇲" },
  { code: "AU", dial: "+61", name: "Australie", flag: "🇦🇺" },
  { code: "AT", dial: "+43", name: "Autriche", flag: "🇦🇹" },
  { code: "AZ", dial: "+994", name: "Azerbaïdjan", flag: "🇦🇿" },
  { code: "BS", dial: "+1242", name: "Bahamas", flag: "🇧🇸" },
  { code: "BH", dial: "+973", name: "Bahreïn", flag: "🇧🇭" },
  { code: "BD", dial: "+880", name: "Bangladesh", flag: "🇧🇩" },
  { code: "BB", dial: "+1246", name: "Barbade", flag: "🇧🇧" },
  { code: "BE", dial: "+32", name: "Belgique", flag: "🇧🇪" },
  { code: "BZ", dial: "+501", name: "Belize", flag: "🇧🇿" },
  { code: "BJ", dial: "+229", name: "Bénin", flag: "🇧🇯" },
  { code: "BT", dial: "+975", name: "Bhoutan", flag: "🇧🇹" },
  { code: "BY", dial: "+375", name: "Biélorussie", flag: "🇧🇾" },
  { code: "BO", dial: "+591", name: "Bolivie", flag: "🇧🇴" },
  { code: "BA", dial: "+387", name: "Bosnie-Herzégovine", flag: "🇧🇦" },
  { code: "BW", dial: "+267", name: "Botswana", flag: "🇧🇼" },
  { code: "BR", dial: "+55", name: "Brésil", flag: "🇧🇷" },
  { code: "BN", dial: "+673", name: "Brunei", flag: "🇧🇳" },
  { code: "BG", dial: "+359", name: "Bulgarie", flag: "🇧🇬" },
  { code: "BF", dial: "+226", name: "Burkina Faso", flag: "🇧🇫" },
  { code: "BI", dial: "+257", name: "Burundi", flag: "🇧🇮" },
  { code: "KH", dial: "+855", name: "Cambodge", flag: "🇰🇭" },
  { code: "CM", dial: "+237", name: "Cameroun", flag: "🇨🇲" },
  { code: "CA", dial: "+1", name: "Canada", flag: "🇨🇦" },
  { code: "CV", dial: "+238", name: "Cap-Vert", flag: "🇨🇻" },
  { code: "CL", dial: "+56", name: "Chili", flag: "🇨🇱" },
  { code: "CN", dial: "+86", name: "Chine", flag: "🇨🇳" },
  { code: "CY", dial: "+357", name: "Chypre", flag: "🇨🇾" },
  { code: "CO", dial: "+57", name: "Colombie", flag: "🇨🇴" },
  { code: "KM", dial: "+269", name: "Comores", flag: "🇰🇲" },
  { code: "CG", dial: "+242", name: "Congo", flag: "🇨🇬" },
  { code: "CD", dial: "+243", name: "Congo (RDC)", flag: "🇨🇩" },
  { code: "KR", dial: "+82", name: "Corée du Sud", flag: "🇰🇷" },
  { code: "CR", dial: "+506", name: "Costa Rica", flag: "🇨🇷" },
  { code: "CI", dial: "+225", name: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "HR", dial: "+385", name: "Croatie", flag: "🇭🇷" },
  { code: "CU", dial: "+53", name: "Cuba", flag: "🇨🇺" },
  { code: "DK", dial: "+45", name: "Danemark", flag: "🇩🇰" },
  { code: "DJ", dial: "+253", name: "Djibouti", flag: "🇩🇯" },
  { code: "DM", dial: "+1767", name: "Dominique", flag: "🇩🇲" },
  { code: "EG", dial: "+20", name: "Égypte", flag: "🇪🇬" },
  { code: "SV", dial: "+503", name: "El Salvador", flag: "🇸🇻" },
  { code: "AE", dial: "+971", name: "Émirats arabes unis", flag: "🇦🇪" },
  { code: "EC", dial: "+593", name: "Équateur", flag: "🇪🇨" },
  { code: "ER", dial: "+291", name: "Érythrée", flag: "🇪🇷" },
  { code: "ES", dial: "+34", name: "Espagne", flag: "🇪🇸" },
  { code: "EE", dial: "+372", name: "Estonie", flag: "🇪🇪" },
  { code: "US", dial: "+1", name: "États-Unis", flag: "🇺🇸" },
  { code: "ET", dial: "+251", name: "Éthiopie", flag: "🇪🇹" },
  { code: "FJ", dial: "+679", name: "Fidji", flag: "🇫🇯" },
  { code: "FI", dial: "+358", name: "Finlande", flag: "🇫🇮" },
  { code: "GA", dial: "+241", name: "Gabon", flag: "🇬🇦" },
  { code: "GM", dial: "+220", name: "Gambie", flag: "🇬🇲" },
  { code: "GE", dial: "+995", name: "Géorgie", flag: "🇬🇪" },
  { code: "GH", dial: "+233", name: "Ghana", flag: "🇬🇭" },
  { code: "GR", dial: "+30", name: "Grèce", flag: "🇬🇷" },
  { code: "GD", dial: "+1473", name: "Grenade", flag: "🇬🇩" },
  { code: "GT", dial: "+502", name: "Guatemala", flag: "🇬🇹" },
  { code: "GN", dial: "+224", name: "Guinée", flag: "🇬🇳" },
  { code: "GW", dial: "+245", name: "Guinée-Bissau", flag: "🇬🇼" },
  { code: "GQ", dial: "+240", name: "Guinée équatoriale", flag: "🇬🇶" },
  { code: "GY", dial: "+592", name: "Guyana", flag: "🇬🇾" },
  { code: "HT", dial: "+509", name: "Haïti", flag: "🇭🇹" },
  { code: "HN", dial: "+504", name: "Honduras", flag: "🇭🇳" },
  { code: "HK", dial: "+852", name: "Hong Kong", flag: "🇭🇰" },
  { code: "HU", dial: "+36", name: "Hongrie", flag: "🇭🇺" },
  { code: "IN", dial: "+91", name: "Inde", flag: "🇮🇳" },
  { code: "ID", dial: "+62", name: "Indonésie", flag: "🇮🇩" },
  { code: "IQ", dial: "+964", name: "Irak", flag: "🇮🇶" },
  { code: "IR", dial: "+98", name: "Iran", flag: "🇮🇷" },
  { code: "IE", dial: "+353", name: "Irlande", flag: "🇮🇪" },
  { code: "IS", dial: "+354", name: "Islande", flag: "🇮🇸" },
  { code: "IL", dial: "+972", name: "Israël", flag: "🇮🇱" },
  { code: "IT", dial: "+39", name: "Italie", flag: "🇮🇹" },
  { code: "JM", dial: "+1876", name: "Jamaïque", flag: "🇯🇲" },
  { code: "JP", dial: "+81", name: "Japon", flag: "🇯🇵" },
  { code: "JO", dial: "+962", name: "Jordanie", flag: "🇯🇴" },
  { code: "KZ", dial: "+7", name: "Kazakhstan", flag: "🇰🇿" },
  { code: "KE", dial: "+254", name: "Kenya", flag: "🇰🇪" },
  { code: "KG", dial: "+996", name: "Kirghizistan", flag: "🇰🇬" },
  { code: "KI", dial: "+686", name: "Kiribati", flag: "🇰🇮" },
  { code: "XK", dial: "+383", name: "Kosovo", flag: "🇽🇰" },
  { code: "KW", dial: "+965", name: "Koweït", flag: "🇰🇼" },
  { code: "LA", dial: "+856", name: "Laos", flag: "🇱🇦" },
  { code: "LS", dial: "+266", name: "Lesotho", flag: "🇱🇸" },
  { code: "LV", dial: "+371", name: "Lettonie", flag: "🇱🇻" },
  { code: "LB", dial: "+961", name: "Liban", flag: "🇱🇧" },
  { code: "LR", dial: "+231", name: "Libéria", flag: "🇱🇷" },
  { code: "LY", dial: "+218", name: "Libye", flag: "🇱🇾" },
  { code: "LI", dial: "+423", name: "Liechtenstein", flag: "🇱🇮" },
  { code: "LT", dial: "+370", name: "Lituanie", flag: "🇱🇹" },
  { code: "LU", dial: "+352", name: "Luxembourg", flag: "🇱🇺" },
  { code: "MO", dial: "+853", name: "Macao", flag: "🇲🇴" },
  { code: "MK", dial: "+389", name: "Macédoine du Nord", flag: "🇲🇰" },
  { code: "MG", dial: "+261", name: "Madagascar", flag: "🇲🇬" },
  { code: "MY", dial: "+60", name: "Malaisie", flag: "🇲🇾" },
  { code: "MW", dial: "+265", name: "Malawi", flag: "🇲🇼" },
  { code: "MV", dial: "+960", name: "Maldives", flag: "🇲🇻" },
  { code: "ML", dial: "+223", name: "Mali", flag: "🇲🇱" },
  { code: "MT", dial: "+356", name: "Malte", flag: "🇲🇹" },
  { code: "MA", dial: "+212", name: "Maroc", flag: "🇲🇦" },
  { code: "MU", dial: "+230", name: "Maurice", flag: "🇲🇺" },
  { code: "MR", dial: "+222", name: "Mauritanie", flag: "🇲🇷" },
  { code: "MX", dial: "+52", name: "Mexique", flag: "🇲🇽" },
  { code: "MD", dial: "+373", name: "Moldavie", flag: "🇲🇩" },
  { code: "MC", dial: "+377", name: "Monaco", flag: "🇲🇨" },
  { code: "MN", dial: "+976", name: "Mongolie", flag: "🇲🇳" },
  { code: "ME", dial: "+382", name: "Monténégro", flag: "🇲🇪" },
  { code: "MZ", dial: "+258", name: "Mozambique", flag: "🇲🇿" },
  { code: "MM", dial: "+95", name: "Myanmar", flag: "🇲🇲" },
  { code: "NA", dial: "+264", name: "Namibie", flag: "🇳🇦" },
  { code: "NP", dial: "+977", name: "Népal", flag: "🇳🇵" },
  { code: "NI", dial: "+505", name: "Nicaragua", flag: "🇳🇮" },
  { code: "NE", dial: "+227", name: "Niger", flag: "🇳🇪" },
  { code: "NG", dial: "+234", name: "Nigéria", flag: "🇳🇬" },
  { code: "NO", dial: "+47", name: "Norvège", flag: "🇳🇴" },
  { code: "NZ", dial: "+64", name: "Nouvelle-Zélande", flag: "🇳🇿" },
  { code: "OM", dial: "+968", name: "Oman", flag: "🇴🇲" },
  { code: "UG", dial: "+256", name: "Ouganda", flag: "🇺🇬" },
  { code: "UZ", dial: "+998", name: "Ouzbékistan", flag: "🇺🇿" },
  { code: "PK", dial: "+92", name: "Pakistan", flag: "🇵🇰" },
  { code: "PA", dial: "+507", name: "Panama", flag: "🇵🇦" },
  { code: "PG", dial: "+675", name: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
  { code: "PY", dial: "+595", name: "Paraguay", flag: "🇵🇾" },
  { code: "NL", dial: "+31", name: "Pays-Bas", flag: "🇳🇱" },
  { code: "PE", dial: "+51", name: "Pérou", flag: "🇵🇪" },
  { code: "PH", dial: "+63", name: "Philippines", flag: "🇵🇭" },
  { code: "PL", dial: "+48", name: "Pologne", flag: "🇵🇱" },
  { code: "PT", dial: "+351", name: "Portugal", flag: "🇵🇹" },
  { code: "QA", dial: "+974", name: "Qatar", flag: "🇶🇦" },
  { code: "CF", dial: "+236", name: "République centrafricaine", flag: "🇨🇫" },
  { code: "DO", dial: "+1809", name: "République dominicaine", flag: "🇩🇴" },
  { code: "CZ", dial: "+420", name: "République tchèque", flag: "🇨🇿" },
  { code: "RO", dial: "+40", name: "Roumanie", flag: "🇷🇴" },
  { code: "GB", dial: "+44", name: "Royaume-Uni", flag: "🇬🇧" },
  { code: "RU", dial: "+7", name: "Russie", flag: "🇷🇺" },
  { code: "RW", dial: "+250", name: "Rwanda", flag: "🇷🇼" },
  { code: "KN", dial: "+1869", name: "Saint-Kitts-et-Nevis", flag: "🇰🇳" },
  { code: "SM", dial: "+378", name: "Saint-Marin", flag: "🇸🇲" },
  { code: "VC", dial: "+1784", name: "Saint-Vincent-et-les-Grenadines", flag: "🇻🇨" },
  { code: "LC", dial: "+1758", name: "Sainte-Lucie", flag: "🇱🇨" },
  { code: "SB", dial: "+677", name: "Salomon", flag: "🇸🇧" },
  { code: "WS", dial: "+685", name: "Samoa", flag: "🇼🇸" },
  { code: "ST", dial: "+239", name: "Sao Tomé-et-Principe", flag: "🇸🇹" },
  { code: "SN", dial: "+221", name: "Sénégal", flag: "🇸🇳" },
  { code: "RS", dial: "+381", name: "Serbie", flag: "🇷🇸" },
  { code: "SC", dial: "+248", name: "Seychelles", flag: "🇸🇨" },
  { code: "SL", dial: "+232", name: "Sierra Leone", flag: "🇸🇱" },
  { code: "SG", dial: "+65", name: "Singapour", flag: "🇸🇬" },
  { code: "SK", dial: "+421", name: "Slovaquie", flag: "🇸🇰" },
  { code: "SI", dial: "+386", name: "Slovénie", flag: "🇸🇮" },
  { code: "SO", dial: "+252", name: "Somalie", flag: "🇸🇴" },
  { code: "SD", dial: "+249", name: "Soudan", flag: "🇸🇩" },
  { code: "SS", dial: "+211", name: "Soudan du Sud", flag: "🇸🇸" },
  { code: "LK", dial: "+94", name: "Sri Lanka", flag: "🇱🇰" },
  { code: "SE", dial: "+46", name: "Suède", flag: "🇸🇪" },
  { code: "CH", dial: "+41", name: "Suisse", flag: "🇨🇭" },
  { code: "SR", dial: "+597", name: "Suriname", flag: "🇸🇷" },
  { code: "SY", dial: "+963", name: "Syrie", flag: "🇸🇾" },
  { code: "TJ", dial: "+992", name: "Tadjikistan", flag: "🇹🇯" },
  { code: "TW", dial: "+886", name: "Taïwan", flag: "🇹🇼" },
  { code: "TZ", dial: "+255", name: "Tanzanie", flag: "🇹🇿" },
  { code: "TD", dial: "+235", name: "Tchad", flag: "🇹🇩" },
  { code: "TH", dial: "+66", name: "Thaïlande", flag: "🇹🇭" },
  { code: "TL", dial: "+670", name: "Timor oriental", flag: "🇹🇱" },
  { code: "TG", dial: "+228", name: "Togo", flag: "🇹🇬" },
  { code: "TO", dial: "+676", name: "Tonga", flag: "🇹🇴" },
  { code: "TT", dial: "+1868", name: "Trinité-et-Tobago", flag: "🇹🇹" },
  { code: "TN", dial: "+216", name: "Tunisie", flag: "🇹🇳" },
  { code: "TM", dial: "+993", name: "Turkménistan", flag: "🇹🇲" },
  { code: "TR", dial: "+90", name: "Turquie", flag: "🇹🇷" },
  { code: "UA", dial: "+380", name: "Ukraine", flag: "🇺🇦" },
  { code: "UY", dial: "+598", name: "Uruguay", flag: "🇺🇾" },
  { code: "VU", dial: "+678", name: "Vanuatu", flag: "🇻🇺" },
  { code: "VA", dial: "+379", name: "Vatican", flag: "🇻🇦" },
  { code: "VE", dial: "+58", name: "Venezuela", flag: "🇻🇪" },
  { code: "VN", dial: "+84", name: "Vietnam", flag: "🇻🇳" },
  { code: "YE", dial: "+967", name: "Yémen", flag: "🇾🇪" },
  { code: "ZM", dial: "+260", name: "Zambie", flag: "🇿🇲" },
  { code: "ZW", dial: "+263", name: "Zimbabwe", flag: "🇿🇼" },
];

REST.sort((a, b) => a.name.localeCompare(b.name, "fr", { sensitivity: "base" }));

export const COUNTRY_DIAL_CODES = [
  { code: "FR", dial: "+33", name: "France", flag: "🇫🇷" },
  ...REST,
];

export const DEFAULT_DIAL_CODE = "FR";
